<template>
  <div class="col-12" v-if="languageCode">
    <div>
      <div
        v-if="history.length === 0"
        class="row mt-2"
      >
        <b>History not applicable for this booking</b>
      </div>
      <div v-if="history">
        <div
          v-for="(booking, index) in history"
          :key="index"
          @click="navToBooking(booking.id)"
        >
          <div
            v-if="booking.id !== activeBookingId"
            class="row mt-1 note-list"
          >
            <div>
              <div class="content-list mb-2">
                <b>Booking Reference:</b>
                <span>{{ booking.bookingReference }}</span>
              </div>
              <div class="content-list mb-2">
                <b>Booking Date:</b>
                <span>{{ booking.bookingDate | formatDate }}</span>
              </div>
              <div class="content-list mb-2">
                <b>Status:</b>
                <span class="content-list-link">{{ booking.status }}</span>
              </div>
              <div
                v-if="booking.transactionAmount && booking.transactionAmount > 0"
                class="content-list"
              >
                <b>Total:</b>
                <span>{{ $n(booking.transactionAmount, 'currency', languageCode) }}</span>
              </div>
            </div>
            <div class="col-12">
              <hr v-if="index + 1 !== history.length">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'History',
    data () {
        return {
            activeBookingId: this.$route.params.bookingId
        }
    },
    computed: mapState({
        history: state => state.booking.bookingHistory,
        languageCode () {
            return this.$store.getters['getLanguageCode']({
                identifier: this.$store.state.airport.selectedAirportId
            })
        }
    }),
    created: function () {
        this.$store.dispatch('getBookingHistory', this.$route.params.bookingId)
    },
    methods: {
        navToBooking (bookingId) {
            this.$router.push({ path: `/booking/${bookingId}` })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>
